import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import Modal from '../../components/Modal/Modal';
import { useForm } from "react-hook-form";
import SettingHandler from '../../Apihander/setting/settingHandler';
import { successToast, errorToast } from '../../utils/notificationUtils';


const PasswordResetPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
    const [loading, setLoading] = useState(false)


    const onsubmitResetPassword = async (payload) => {
        // console.log(payload, 'onreset password', token ,'reset password token')
        try {
            setLoading(true)
            const data = await SettingHandler.doHandlerResetPassword(token, payload)
           
            if (data.statusCode === 200) {
                successToast(data.message)
                navigate('/')
                setLoading(false)
                setOpenResetPasswordModal(false)
                reset()
            } else {
                const errorMessage =
                    data?.response?.data?.message || data.message || "An error occurred";
                errorToast(errorMessage)
                setLoading(false)
            }
        } catch (error) {

            console.log('Error on Contact :', error)
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            errorToast(errorMessage);
            setLoading(false)

        }
    }


    useEffect(() => {
        if (token) {
            // console.log(token)
            localStorage.setItem('ResetToken', token)
            setOpenResetPasswordModal(true); // Automatically open the modal
        }
    }, [token]);
    return (
        <div>
            {openResetPasswordModal && (
                <Modal onClose={() => { setOpenResetPasswordModal(false); reset() }} modaltxt={"Reset Password"}>
                    <div>
                        <div className=" d-flex justify-content-center text-center" style={{ padding: '44px 0px' }}>
                            <form onSubmit={handleSubmit(onsubmitResetPassword)}
                                noValidate
                            >
                                <div className="row justify-content-between text-left">
                                    <div className="form-group col-sm-12 col-md-12 flex-column d-flex m-2">
                                        <input type="password" id="password" name="password" placeholder="Enter your password"
                                            className={`form-control custom-input-field ${errors.password ? 'error' : ''}`}
                                            style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                            {...register("password", {
                                                required: 'This field is required',
                                                minLength: {
                                                    value: 6,
                                                    message: 'Password must be between 6 and 12 characters',
                                                },
                                                maxLength: {
                                                    value: 12,
                                                    message: 'Password must be between 6 and 12 characters',
                                                },
                                            })} />
                                        {errors.password && <span className="error-message">{errors.password.message}</span>}
                                    </div>
                                    <div className="form-group col-sm-12 col-md-12 flex-column d-flex m-2">
                                        <input type="password" id="confirmPassword" name="confirmPassword" placeholder="Enter your confirmPassword"
                                            // className="form-control input-field"
                                            className={`form-control custom-input-field ${errors.confirmPassword ? 'error' : ''}`}

                                            style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                            {...register("confirmPassword", {
                                                required: 'This field is required',
                                                minLength: {
                                                    value: 6,
                                                    message: 'Password must be between 6 and 12 characters',
                                                },
                                                maxLength: {
                                                    value: 12,
                                                    message: 'Password must be between 6 and 12 characters',
                                                },
                                                validate: (value) => {
                                                    if (value !== watch('password')) {
                                                        return 'Passwords do not match with new password';
                                                    }
                                                    return true;
                                                },
                                            })}
                                        />
                                        {errors.confirmPassword && <span className="error-message">{errors.confirmPassword.message}</span>}
                                    </div>

                                </div>

                                <div className="row justify-content-center my-4">
                                    <div className="form-group col-sm-6">
                                        <button type='submit'
                                            style={{ width: '203px', height: '54px', border: 'none', borderRadius: '8px', background: '#334155', color: 'white', cursor: loading ? 'not-allowed' : 'pointer' }}
                                            disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <div
                                                        className="spinner-border"
                                                        role="status"
                                                        style={{ width: "1.5rem", height: "1.5rem" }}
                                                    >
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </>
                                            ) : (
                                                <span style={{ fontFamily: 'Metropolis', fontWeight: '700', font: '16px', lineHeight: '20px', }}>Submit</span>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal >
            )}
        </div>
    )
}

export default PasswordResetPage
